import {
  getDefault,
  constants as pluginLibConstants,
} from '@pearsontechnology/aero-plugin-api';

import AnnotationsService from './annotation/AnnotationsService';
import APILifecycleService from './lifecycle/APILifecycleService';
import APICoursewareItemService from './coursewareItem/APICoursewareItemService';
import AssetService from './assets/AssetService';
import AuthService from './auth/AuthService';
import ClassService from './ClassService';
import CompetencyService from './competency/CompetencyService';
import CoursewareTargetService from './coursewareTarget/CoursewareTargetService';
import DeprecatedResourceService from './DeprecatedResourceService';
import HistoryService from './history/HistoryService';
import LTIService from './LTIService';
import PluginService from './PluginService';
import QueryService from './pluginQueryService';
import RouteService from './route/RouteService';
import ThemeService from './theme/ThemeService';
import UserService from './UserService/UserService';
import EventService from './EventService';
import FeatureFlagServiceFacade from './FeatureFlagService/FeatureFlagServiceFacade';
import LoggerService from './logger/LoggerService';

const registerPluginServices = () => {
  const { services } = getDefault();

  services
    .add(pluginLibConstants.ANNOTATIONS_SERVICE, AnnotationsService)
    .add(pluginLibConstants.ASSET_SERVICE, AssetService)
    .add(pluginLibConstants.AUTH_SERVICE, AuthService)
    .add(pluginLibConstants.CLASS_SERVICE, ClassService)
    .add(pluginLibConstants.COMPETENCY_SERVICE, CompetencyService)
    .add(pluginLibConstants.COURSEWARE_ITEM_SERVICE, APICoursewareItemService)
    .add(pluginLibConstants.COURSEWARE_TARGET_SERVICE, CoursewareTargetService)
    .add(pluginLibConstants.DEPRECATED_RESOURCE_SERVICE, DeprecatedResourceService)
    .add(pluginLibConstants.DRAG_STATE_SERVICE, { build: () => ({}) })
    .add(pluginLibConstants.EDITOR_SERVICE,
      {
        build: () => (
          {
            subscribeToSelection: () => { },
            clearSelection: () => { },
            addSelection: () => { },
          }),
      })
    .add(pluginLibConstants.HISTORY_SERVICE, HistoryService)
    .add(pluginLibConstants.LIFECYCLE_SERVICE, APILifecycleService)
    .add(pluginLibConstants.LTI_SERVICE, LTIService)
    .add(pluginLibConstants.PLUGIN_SERVICE, PluginService)
    .add(pluginLibConstants.QUERY_SERVICE, QueryService)
    .add(pluginLibConstants.ROUTE_SERVICE, RouteService)
    .add(pluginLibConstants.USER_SERVICE, UserService)
    .add(pluginLibConstants.THEME_SERVICE, ThemeService)
    .add(pluginLibConstants.EVENT_SERVICE, EventService)
    .add(pluginLibConstants.FEATURE_FLAG_SERVICE, FeatureFlagServiceFacade)
    .add(pluginLibConstants.LOGGER_SERVICE, LoggerService);

  return {
    services,
  };
};

export default registerPluginServices;
